const Styles = {
    'MapContainer': 'GoogleMaps_MapContainer--f8b3a5c1',
    'ErrorText': 'GoogleMaps_ErrorText--0a6e3155',
    'ClusterIconLabel': 'GoogleMaps_ClusterIconLabel--0d347773'
};

export default Styles;